module.exports = require("./../../_gen/starling/assets/XmlFactory");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/assets/XmlFactory.js
// module id = 157
// module chunks = 0